import axios from 'axios';
import { Global } from '../Global';

const joinUrl = (domain: string | undefined, path: string): string => {
  if (!domain) {
    return path.startsWith('/') ? path : `/${path}`;
  }
  const normalizedDomain = domain.replace(/\/+$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedDomain}${normalizedPath}`;
};

export const CAPTCHA_DOMAIN =
  process.env.REACT_APP_CAPTCHA_DOMAIN || process.env.REACT_APP_API_DOMAIN;

/** TIANAI 接口使用原生 `{code, data}`，不包 Request。 */
export const postTianai = async <T>(
  path: string,
  body: unknown = {},
): Promise<T | null> => {
  if (Global.isMockMode()) {
    return null;
  }
  try {
    const response = await axios.post<{ code: number; data: T }>(
      joinUrl(CAPTCHA_DOMAIN, path),
      body,
      { headers: { 'Content-Type': 'application/json; charset=utf-8' } },
    );
    if (response.data?.code !== 200) {
      return null;
    }
    return response.data.data ?? null;
  } catch {
    return null;
  }
};
